import { render, staticRenderFns } from "./ModalEditLoggedUser.vue?vue&type=template&id=01970d86&"
import script from "./ModalEditLoggedUser.vue?vue&type=script&lang=js&"
export * from "./ModalEditLoggedUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports